'use client'

import { Text } from '@vinted/web-ui'
import classNames from 'classnames'

import { FormattedMessage } from '@marketplace-web/i18n/i18n-feature'
import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

type Props = {
  isCurrentAuthor: boolean
  onClick: () => Promise<void>
}

const SuspiciousPhoto = ({ isCurrentAuthor, onClick }: Props) => {
  const photoMessageClass = classNames('conversation-message__suspicious-overlay', {
    'conversation-message__current-author': isCurrentAuthor,
  })

  return (
    <span role="presentation" className={photoMessageClass} onClick={onClick}>
      <Text
        as="h4"
        type={Text.Type.Caption}
        width={Text.Width.Parent}
        alignment={Text.Alignment.Center}
        theme="inverse"
      >
        <div className="u-ui-padding-regular">
          <ShowAtBreakpoint breakpoint="desktops">
            <FormattedMessage id="conversation.suspicious_photo.desktops" />
          </ShowAtBreakpoint>

          <ShowAtBreakpoint breakpoint="portables">
            <FormattedMessage id="conversation.suspicious_photo.portables" />
          </ShowAtBreakpoint>
        </div>
      </Text>
    </span>
  )
}

export default SuspiciousPhoto
